const hsdata2023=[

 
  {
    Name: "Krish amitkumar rathod",
    Mail: "leorathod91011@gmail.com",
    Roll: "19BEC105",
    College: "San francisco state university",
    Admission: "Gre, ielts",
  },
  {
    Name: "Ratnesh mehta",
    Mail: "19bec107@nirmauni.ac.in",
    Roll: "19BEC107",
    College:
      "University of illinois, ",
    Admission: "Gre, ielts",
  },

  {
    Name: "Utsav raj goyal",
    Mail: "Utsavrajgoyal40@gmail.com",
    Roll: "19BEC141",
    College: "London school of economics",
    Admission: "Gmat",
  },
];


export default hsdata2023;